import React from "react";
import { t } from "ttag";

import { Link } from "../../common/Link";
import { IWebPageURL } from "../../models/nominals";
import { trackSleepExpertEvent } from "../../utils/analytics";
import { urls } from "../../utils/urls";
import { getChatConnector } from "./index";

interface IProps {
    className?: string;
    chatOnlineText?: string | React.ReactNode;
    chatOfflineText?: string | React.ReactNode;
    hideIfOffline?: boolean;
    chatOfflineLink: IWebPageURL;
}

interface IState {
    isChatOnline: boolean;
}

// TODO(ssr, LEVEL 4 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 4/10 due to simple state management, async componentDidMount, and straightforward event handler logic.
export class ChatLink extends React.Component<IProps, IState> {
    public state = {
        isChatOnline: false,
    };

    async componentDidMount() {
        try {
            const { isOnline } = await getChatConnector().init();
            this.setState({
                isChatOnline: isOnline,
            });
        } catch (e) {
            console.error(e);
        }
    }

    private readonly onClick = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        if (this.state.isChatOnline) {
            getChatConnector().openChat();
            trackSleepExpertEvent("chat");
        } else {
            urls.navigateToURL(this.props.chatOfflineLink);
        }
    };

    render() {
        if (this.state.isChatOnline) {
            return (
                <button className={this.props.className} onClick={this.onClick}>
                    {this.props.chatOnlineText || t`Chat`}
                </button>
            );
        }
        if (this.props.hideIfOffline) {
            return null;
        }
        return (
            <Link
                className={this.props.className}
                href={this.props.chatOfflineLink}
            >
                {this.props.chatOfflineText || t`Contact Us`}
            </Link>
        );
    }
}
